<template lang="pug">
v-menu(
  ref="menu"
  v-model="menu"
  :close-on-content-click="false"
  transition="scale-transition"
  offset-y
  min-width="auto"
)
  template( v-slot:activator="{ on, attrs }")
    v-text-field(
      :value="formated"
      readonly
      v-bind="{ ...attrs, ...$attrs }"
      v-on="on"
      clearable
      @click:clear="date = null"
    )
  v-date-picker(
    v-model="date"
    no-title
    scrollable
  )
    //- v-btn(
    //-   text
    //-   color="primary"
    //-   @click="menu = false"
    //- ) Отмена
    //- v-btn(
    //-   text
    //-   color="primary"
    //-   @click="$refs.menu.save(date)"
    //- ) Сохранить
</template>
<script>
export default {
  props: {
    value: { type: String, default: null },
  },
  data() {
    return {
      date: this.value,
      menu: false,
    };
  },
  computed: {
    formated() {
      if (this.date) {
        return this.date.split('-').reverse().join('.');
      }
      return null;
    },
  },
  watch: {
    date(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
};
</script>
